import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { blogFilter, blogSort } from "../features/filters/filtersSlice";

export default function FilterBlog() {
  const dispatch = useDispatch();
  const [radioValue, setRadioValue] = useState("all");

  function handleChange(value) {
    dispatch(blogSort(value));
  }

  function filterBlogByChange(value) {
    setRadioValue(value);
    dispatch(blogFilter(value));
  }

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            onChange={(e) => handleChange(e.target.value)}
            name="sort"
            id="lws-sort"
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                checked={radioValue === "all"}
                className="radio"
                value="all"
                onChange={(e) => filterBlogByChange(e.target.value)}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                className="radio"
                value="saved"
                checked={radioValue === "saved"}
                onChange={(e) => filterBlogByChange(e.target.value)}
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
